var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNyc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 16,
    viewBox: "0 0 39 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_492_886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5047 0.188656V15.8096H9.03675L3.37311 5.82282L3.46798 15.8113H0V0.188656H3.6103L9.13163 9.94094L9.03675 0.188656H12.5047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4626 0.188656L22.1547 10.5324V15.8096H18.6868V10.5324L13.3772 0.188656H17.1755L20.1726 6.79159H20.6673L23.6405 0.188656H27.4626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0137 3.66773C27.6591 2.46951 28.5825 1.55683 29.7853 0.934778C30.9882 0.311026 32.4079 0 34.0445 0C35.1135 0 36.0453 0.0985766 36.8399 0.29573C37.6345 0.492883 38.2444 0.701933 38.6679 0.922881V4.42575C38.0699 4.04674 37.3786 3.73911 36.5925 3.50287C35.8064 3.26662 34.9966 3.14765 34.1631 3.14765C32.7315 3.14765 31.5998 3.55046 30.7663 4.35437C29.9327 5.15828 29.516 6.37349 29.516 8C29.516 11.2343 31.1203 12.8523 34.3291 12.8523C35.2253 12.8523 36.1097 12.7096 36.9839 12.4257C37.8581 12.1419 38.529 11.8343 39.0017 11.5029V14.8885C38.6239 15.1417 37.9869 15.3898 37.0906 15.6346C36.1944 15.8793 35.2101 16.0017 34.1411 16.0017C32.3317 16.0017 30.8222 15.6584 29.6108 14.9717C28.3995 14.2851 27.5033 13.3435 26.9205 12.1436C26.3377 10.9454 26.048 9.56363 26.048 8.0017C26.048 6.314 26.3699 4.86934 27.0154 3.67113L27.0137 3.66773Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_492_886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNyc);
export default __webpack_public_path__ + "static/media/NYC.d461ec327eb2dd47dadcc02d77402d36.svg";
export { ForwardRef as ReactComponent };